import { getVariantHandler } from "../../../../constants";
const mapCombinationStatusToVariant = new Proxy({
    Cancelled: "CombinationVoid",
    Lost: "CombinationLost",
    Open: "CombinationOpen",
    Void: "CombinationVoid",
    Won: "CombinationWon",
    DeadHeatReduction: "CombinationWon",
    CashOut: "CombinationWon",
    EarlyExit: "CombinationVoid"
}, getVariantHandler);
export { mapCombinationStatusToVariant, };
//# sourceMappingURL=_localVariants.js.map